<template>
  <LMap ref="map" :zoom="mapZoom" :center="mapCenter" :options="mapOptions" class="mapa-claro"
    style="height: 400px; width: 100%;" @ready="onMapReady">
    <LTileLayer :url="tileProvider.url" :attribution="tileProvider.attribution"></LTileLayer>

    <template v-for="(passenger, index) in passengers">
      <LMarker v-if="passenger.pickup && passenger.pickup.lat && passenger.pickup.lng"
        :key="`pickup-${passenger.id || index}`" :lat-lng="[passenger.pickup.lat, passenger.pickup.lng]">
        <LIcon :icon-anchor="[10, 10]" :icon-size="[20, 20]" class-name="custom-div-icon">
          <div :style="{ backgroundColor: routeColors[index % routeColors.length], border: '2px solid white' }"
            class="custom-marker-icon"></div>
        </LIcon>
        <LPopup>
          <div>
            <span><strong>Passageiro:</strong> {{ passenger.passenger.name || passenger.passenger }}</span><br />
            <br />
            <span><strong>Itinerário:</strong> {{ passenger.itinerary_name }}</span><br />
            <span><strong>Origem:</strong> {{ passenger.pickup.address }}</span><br />
            <span><strong>Destino:</strong> {{ passenger.dropoff.address }}</span><br />
            <span><strong>Distância:</strong> {{ passenger.distance }}</span><br />
            <span><strong>Duração:</strong> {{ passenger.duration }}</span><br />

            <div :style="{ backgroundColor: routeColors[index % routeColors.length], border: '2px solid white' }"
              class="custom-marker-icon"></div>
          </div>
        </LPopup>
      </LMarker>

      <LMarker v-if="passenger.dropoff && passenger.dropoff.lat && passenger.dropoff.lng"
        :key="`dropoff-${passenger.id || index}`" :lat-lng="[passenger.dropoff.lat, passenger.dropoff.lng]">
        <LIcon :icon-anchor="[10, 10]" :icon-size="[20, 20]" class-name="custom-div-icon">
          <div :style="{ backgroundColor: routeColors[index % routeColors.length], border: '2px solid white' }"
            class="custom-marker-icon"></div>
        </LIcon>
        <LPopup>
          <!-- <div :style="{ backgroundColor: routeColors[index % routeColors.length], border: '2px solid white' }"
            class="custom-marker-icon"></div> -->
          <div>
            <span><strong>Passageiro:</strong> {{ passenger.passenger.name || passenger.passenger }}</span><br />
            <br />
            <span><strong>Itinerário:</strong> {{ passenger.itinerary_name }}</span><br />
            <span><strong>Origem:</strong> {{ passenger.pickup.address }}</span><br />
            <span><strong>Destino:</strong> {{ passenger.dropoff.address }}</span><br />
            <span><strong>Distância:</strong> {{ passenger.distance }}</span><br />
            <span><strong>Duração:</strong> {{ passenger.duration }}</span><br />

            <div :style="{ backgroundColor: routeColors[index % routeColors.length], border: '2px solid white' }"
              class="custom-marker-icon"></div>
          </div>
        </LPopup>
      </LMarker>
    </template>

    <LPolyline v-for="(route, index) in routesData" :key="`route-${index}`" :lat-lngs="route.path" :color="route.color"
      :weight="6" :opacity="0.8"></LPolyline>
  </LMap>
</template>

<script>
import { LMap, LTileLayer, LMarker, LIcon, LPolyline, LPopup } from 'vue2-leaflet';
import L from 'leaflet';
import axios from 'axios';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  name: 'TripMap',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPolyline,
    LPopup
  },
  props: {
    passengers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      osrmAxiosInstance: null,
      mapCenter: { lat: -29.983164313555072, lng: -51.139299945774184 },
      mapZoom: 12,
      routeColors: [
        '#E91E63', '#2196F3', '#4CAF50', '#FFC107', '#9C27B0',
        '#FF5722', '#00BCD4', '#795548', '#607D8B', '#F44336',
      ],
      mapOptions: {
        zoomControl: true,
      },
      // OpenStreetMap direto: o CARTO passou a exigir chave de API e
      // estampava "API KEY REQUIRED" por cima do mapa.
      tileProvider: {
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      },
      routesData: [], // Armazena os dados das polylines para renderizar
      mapInstance: null, // Referência a instância do mapa Leaflet
    };
  },
  created() {
    this.osrmAxiosInstance = axios.create();
    delete this.osrmAxiosInstance.defaults.headers.common['Authorization'];
    this.osrmAxiosInstance.defaults.timeout = 10000; //timeout para 10 segundos
  },
  watch: {
    passengers: {
      handler() {
        this.drawRoutes();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onMapReady(map) {
      this.mapInstance = map;
      this.drawRoutes();
    },

    invalidateMapSize() {
      if (this.mapInstance) {
        this.mapInstance.invalidateSize();
      }
    },

    centerAt(location) {
      if (this.mapInstance) {
        this.mapInstance.setView([location.lat, location.lng], this.mapZoom);
      }
    },
    clearRoutes() {
      this.routesData = [];
    },
    async drawRoutes() {
      this.clearRoutes();
      if (!this.mapInstance || !this.passengers.length) {
        this.$emit('routes-calculated', []); // emite vazio se não há passageiros ou mapa
        return;
      }

      let bounds = new L.LatLngBounds();
      const calculatedRouteDetails = []; //armazenar distância e duração

      //requisição OSRM
      const routePromises = this.passengers.map(async (passenger, i) => {
        const color = this.routeColors[i % this.routeColors.length];

        if (!passenger.pickup || !passenger.dropoff || !passenger.pickup.lat || !passenger.pickup.lng || !passenger.dropoff.lat || !passenger.dropoff.lng) {
          console.warn(`Passageiro ${passenger.passenger} não tem pontos de origem/destino válidos (lat/lng) para rota.`, passenger);
          calculatedRouteDetails.push({
            passengerId: passenger.id,
            distance: null,
            duration: null,
          });
          return null; // retorna null para indicar que não tem rota válida
        }

        try {
          const origin = `${passenger.pickup.lng},${passenger.pickup.lat}`;
          const destination = `${passenger.dropoff.lng},${passenger.dropoff.lat}`;
          const routeUrl = `https://router.project-osrm.org/route/v1/driving/${origin};${destination}?overview=full&geometries=geojson`;

          const response = await this.osrmAxiosInstance.get(routeUrl);

          if (response.data && response.data.routes && response.data.routes.length > 0) {
            const route = response.data.routes[0];
            const geojsonPath = route.geometry.coordinates;

            const latLngPath = geojsonPath.map(coord => [coord[1], coord[0]]);

            this.routesData.push({
              path: latLngPath,
              color: color,
            });

            // estende os limites do mapa
            bounds.extend(L.latLng(passenger.pickup.lat, passenger.pickup.lng));
            bounds.extend(L.latLng(passenger.dropoff.lat, passenger.dropoff.lng));

            //distância e duração
            const distanceKm = (route.distance / 1000).toFixed(2); // Distância em metros, converter para km
            const durationMinutes = (route.duration / 60).toFixed(0); // Duração em segundos, converter para minutos

            calculatedRouteDetails.push({
              passengerId: passenger.id,
              distance: parseFloat(distanceKm),
              duration: parseInt(durationMinutes),
            });
            return { type: 'success' }; // Indica sucesso
          } else {
            console.error(`Nenhuma rota encontrada para ${passenger.passenger}. Resposta:`, response.data);
            calculatedRouteDetails.push({
              passengerId: passenger.id,
              distance: null,
              duration: null,
            });
            return { type: 'no-route' }; // Indica que nenhuma rota foi encontrada
          }

        } catch (error) {
          console.error(`Falha ao desenhar rota para ${passenger.passenger}:`, error);
          if (error.response) {
            console.error('Resposta de erro do servidor:', error.response.data);
          }
          calculatedRouteDetails.push({
            passengerId: passenger.id,
            distance: null,
            duration: null,
          });
          return { type: 'error', error }; // Indica erro
        }
      });

      // aguarda todas as promessas serem resolvidas
      await Promise.allSettled(routePromises);

      //evento com todos os detalhes calculados após as requisições
      this.$emit('routes-calculated', calculatedRouteDetails);

      if (bounds.isValid()) {
        this.mapInstance.fitBounds(bounds, { padding: [50, 50] });
      }
    },


  },
  beforeDestroy() {
    this.clearRoutes();
  },
};
</script>

<style scoped>
/* Visual claro estilo "Positron": dessatura so a camada de tiles do OSM.
   Rotas, pins e controles ficam em panes separados e mantem as cores. */
.mapa-claro ::v-deep .leaflet-tile-pane {
  filter: grayscale(100%) brightness(104%) contrast(88%);
}
.custom-marker-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 12px;
}
</style>